import React from 'react';
import FilterableTable from '../filters/FilterableTable';
import TravelOrderRow from './TravelOrderRow';

const TravelOrderTable = ({
  dispatch,
  travelOrderReducer,
  findAllTravelOrderPageble,
  updateTravelOrder,
  deleteTravelOrder,
  clearValidationErrors,
  municipalities,
}) => {
  const { travelOrderList, totalElements } = travelOrderReducer;

  let travelOrderNameList = travelOrderList.map((travelOrder, index) => (
    <TravelOrderRow
      municipalities={municipalities}
      key={travelOrder.id}
      travelOrder={travelOrder}
      deleteTravelOrder={deleteTravelOrder}
      updateTravelOrder={updateTravelOrder}
      dispatch={dispatch}
      clearValidationErrors={clearValidationErrors}
      travelOrderReducer={travelOrderReducer}
    />
  ));

  const columns = [
    {
      id: 'Datum i vreme polaska',
      name: 'Datum i vreme polaska',
      filter: {
        field: 'startDateTime',
        value: '',
        type: 'DATE_LIKE',
      },
    },
    {
      id: 'Datum i vreme dolaska',
      name: 'Datum i vreme dolaska',
      filter: {
        field: 'returnDateTime',
        value: '',
        type: 'DATE_LIKE',
      },
    },
    {
      id: 'Mesto polaska',
      name: 'Mesto polaska',
      filter: {
        field: 'startPointId',
        value: '',
        type: 'JSON_LOOKUP',
        clause: 'ID',
        fieldLabel: 'codeLists/cityCodeList.json|name',
      },
    },
    {
      id: 'Mesto dolaska',
      name: 'Mesto dolaska',
      filter: {
        field: 'returnPointId',
        value: '',
        type: 'JSON_LOOKUP',
        clause: 'ID',
        fieldLabel: 'codeLists/cityCodeList.json|name',
      },
    },
    {
      id: 'Natočeno goriva',
      name: 'Natočeno goriva',
      filter: {
        field: 'refueling',
        value: '',
        type: 'DOUBLE',
    clause: 'like'
      },
    },
    { id: 'Измена', name: 'Измена' },
    { id: 'Брисање', name: 'Брисање' },
    { id: 'Preuzmi', name: 'Preuzmi' },
  ];

  return (
    <>
      <FilterableTable
        tableStyle="table-container-with-row-below"
        columns={columns}
        action={findAllTravelOrderPageble}
        rows={travelOrderNameList}
        totalElements={totalElements}
        filterPosition
      ></FilterableTable>
    </>
  );
};

export default TravelOrderTable;
